import { render, staticRenderFns } from "./DropDownBox.vue?vue&type=template&id=a372edcc&scoped=true&"
import script from "./DropDownBox.vue?vue&type=script&lang=js&"
export * from "./DropDownBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372edcc",
  null
  
)

export default component.exports